import React from 'react'
import { Button } from 'react-bootstrap'

interface Props {
    handleActionModal: () => void;
}

export const ModalConfirmThisFit = React.memo(({ handleActionModal }: Props) => {


    return (
        <div>
            <a href="#close" title="Close" className="close">
                <i className="far fa-times-circle text-primary"></i>
            </a>
            <div className="circulo mb-2 mt-4">
                <i className="fas fa-thumbs-up"></i>
            </div>
            <p className='my-2'>This step will be marked as Completed.</p>
            <div className="contenedor-btns my-3">
                <a href="#close" className='me-2 boton-cancel-modal' >
                    {/* <Button
                        type="button"
                        variant="primary"
                        className='estilos-boton'
                    >
                        Cancel
                    </Button> */}
                    <button
                        type="button"
                        className="btn btn-outline-primary"

                    >
                        Cancel
                    </button>
                </a>
                <Button
                    type="button"
                    variant="primary"
                    className='estilos-boton '
                    onClick={handleActionModal}
                >
                    Yes, Continue
                </Button>
            </div>

        </div>
    )
})
